<template>
  <transition name="fades">
    <div id="proctorSQDialog" class="proctorSQDialog" style="z-index: 2001" v-if="show">
      <div class="dialogBox" :class="{remaidBox: code && text.length > 200}">
        <div class="title bold">{{title}}</div>
        <div class="text" :class="{remaid: code && text.length > 200}" v-if="text">{{text}}</div>
        <div v-if="img" class="img">
          <img :src="img" alt="" srcset="">
        </div>
        <div v-if="yesTxt" class="btn">
          <div class="primary" @click="yesBtn">{{yesTxt}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'proctorSQDialog',
  data () {
    return {
      show: false,
      title: '',
      text: '',
      yesTxt: '确定',
      confirm: null,
      img: ''
    }
  },
  computed: {},
  watch: {
    newShowHelp (val) {
      if (!val) {
        this.show = false
      }
    }
  },
  mounted () {},
  methods: {
    yesBtn () {
      this.confirm && this.confirm()
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
$width: 100vw/1920;
::-webkit-scrollbar {
  /*滚动条整体样式*/
  display: block;
  width : 8*$width;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 120*$width;
}
::-webkit-scrollbar-corner{
  display: none;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4*$width;
  background: #D9DAE3;
}
.proctorSQDialog{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .dialogBox{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    background: #FFFFFF;
    border-radius: 32*$width;
    box-sizing: border-box;
    text-align: center;
    min-width: 480*$width;
    max-width: 730*$width;
    min-height: 370*$width;
    max-height: 700*$width;
    background-image: url('https://img.webloom.cn/img/SQDig.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 20*$width;
    padding: 55*$width 110*$width;
    .title{
      font-size: 22*$width;
      line-height: 28*$width;
      font-weight: bold;
      font-size: 22*$width;
      color: #FFFFFF;
    }
    .text{
      font-size: 18*$width;
      margin-top: 30*$width;
      font-weight: 400;
      font-size: 18*$width;
      color: #FFFFFF;
      line-height: 29*$width;
      word-break: break-word;
      // white-space:pre;
    }
    .remaid{
      max-height: 400*$width;
      overflow: hidden;
      overflow-y: scroll;
    }
    .img{
      padding: 30*$width 57*$width 0*$width;
      img{
        width: 430*$width;
      }
    }
    .btn{
      margin-top: 40*$width;
      .primary{
        cursor: pointer;
        width: 260*$width;
        height: 48*$width;
        background: linear-gradient(270deg, #FFBB2E 0%, #FF6324 100%);
        border-radius: 5*$width;
        font-size: 18*$width;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        line-height: 48*$width;
      }
    }
  }
  .remaidBox{
    width: 630*$width;
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/proctorSQDialog/src/main.vue